exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control-admin {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\nh3 {\r\n    margin-top: 0 !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/refund-dialog/refund-dialog.component.css
// module id = ../../../../../src/app/component/refund-dialog/refund-dialog.component.css
// module chunks = main